// Custom events for quick view loaded and for Cart auto refresh
(() => {
  const QUICK_CART_SELECTORS = ['.quick-cart__items', '.quick-cart__heading', '.quick-cart__subtotal', '.quick-cart__discounts'];

  const observeQuickProductModal = () => {
    const modalContent = document.querySelector('.quick-product-modal__content');
    if (!modalContent) return;

    new MutationObserver((mutations) => {
      for (const { addedNodes } of mutations) {
        for (const node of addedNodes) {
          if (node.nodeType !== 1) continue;
          const productEl = node.matches?.('[data-quick-product]') ? node : node.querySelector?.('[data-quick-product]');
          if (productEl) {
            window.dispatchEvent(new CustomEvent('quick-view:loaded', {
              detail: { type: productEl.dataset.quickProductType, productHandle: productEl.dataset.productHandle }
            }));
            return;
          }
        }
      }
    }).observe(modalContent, { childList: true });
  };

  let refreshInFlight = null;

  const refreshCartItems = () => {
    if (refreshInFlight) return refreshInFlight;

    const quickCart = document.querySelector('[data-section-type="quick-cart"]');
    if (!quickCart) return Promise.resolve();

    const cartBase = window.theme?.routes?.cart?.base || '/cart';

    refreshInFlight = fetch(`${cartBase}?section_id=${quickCart.dataset.sectionId}`, { cache: 'no-store' })
      .then((r) => r.text())
      .then((html) => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;

        const cartHasItems = !!quickCart.querySelector('.quick-cart__items');
        const responseHasItems = !!tmp.querySelector('.quick-cart__items');

        if (cartHasItems === responseHasItems) {
          QUICK_CART_SELECTORS.forEach((sel) => {
            const newEl = tmp.querySelector(sel);
            const oldEl = quickCart.querySelector(sel);
            if (newEl && oldEl) oldEl.innerHTML = newEl.innerHTML;
          });
        } else {
          const newContainer = tmp.querySelector('.quick-cart__container');
          const oldContainer = quickCart.querySelector('.quick-cart__container');
          if (newContainer && oldContainer) oldContainer.innerHTML = newContainer.innerHTML;
        }

        window.dispatchEvent(new CustomEvent('cart-items:refreshed'));
      })
      .catch((err) => console.error('[cart-items:refresh] failed', err))
      .finally(() => { refreshInFlight = null; });

    return refreshInFlight;
  };

  window.addEventListener('cart-items:refresh', refreshCartItems);
  window.refreshCartItems = refreshCartItems;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeQuickProductModal);
  } else {
    observeQuickProductModal();
  }
})();

// Cart Auto-Add
  window.addEventListener("abra:cart:changed", () => {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart-items:refresh", {
        bubbles: true,
      })
    );
  });